import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _styled from "@emotion/styled-base";
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
import AKInlineDialog from '@atlaskit/inline-dialog';
import React, { PureComponent } from 'react';
/**
 * A wrapper over Atlaskit's Inline dialog component that
 * functions like a tooltip, i.e. is invoked on hover
 * https://atlaskit.atlassian.com/packages/core/inline-dialog
 */

export const RichTooltipContainer = _styled("span", {
  target: "e1l6eq9s0",
  label: "RichTooltipContainer"
})(process.env.NODE_ENV === "production" ? {
  name: "1c3h18e",
  styles: "flex:1 0 auto;"
} : {
  name: "1c3h18e",
  styles: "flex:1 0 auto;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
const RICH_TOOLTIP_CLASS = 'rich_tooltip__container';
export default class RichTooltip extends PureComponent {
  constructor() {
    super(...arguments);
    _defineProperty(this, "showTimerId", void 0);
    _defineProperty(this, "hideTimerId", void 0);
    _defineProperty(this, "isFocused", void 0);
    _defineProperty(this, "state", {
      isOpen: false
    });
    _defineProperty(this, "handleFocusChange", e => {
      const isTooltipChild = target => !(target instanceof HTMLElement) || !target.closest(".".concat(RICH_TOOLTIP_CLASS));
      if (isTooltipChild(e.target)) {
        this.isFocused = false;
        this.setState({
          isOpen: false
        });
      }
    });
    _defineProperty(this, "handleMouseEnter", () => {
      clearTimeout(this.hideTimerId);
      this.showTimerId = setTimeout(() => {
        this.setState({
          isOpen: true
        });
      }, this.props.delay);
    });
    _defineProperty(this, "handleMouseLeave", () => {
      if (this.isFocused) return;
      clearTimeout(this.showTimerId);

      // Add a delay, allowing some time for the cursor to
      // hop onto the tooltip area without close being triggered
      this.hideTimerId = setTimeout(() => {
        this.setState({
          isOpen: false
        });
      }, 150);
    });
    _defineProperty(this, "handleFocus", () => {
      this.isFocused = true;
      this.setState({
        isOpen: true
      });
    });
    _defineProperty(this, "handleContentBlur", () => {
      this.isFocused = false;
      this.setState({
        isOpen: false
      });
    });
  }
  componentDidMount() {
    document.addEventListener('focus', this.handleFocusChange, true);
  }
  componentWillUnmount() {
    document.removeEventListener('focus', this.handleFocusChange, true);
  }
  render() {
    const {
      isOpen
    } = this.state;
    const {
      children,
      content
    } = this.props;
    return /*#__PURE__*/React.createElement(RichTooltipContainer, {
      className: RICH_TOOLTIP_CLASS,
      onMouseEnter: this.handleMouseEnter,
      onMouseLeave: this.handleMouseLeave
    }, /*#__PURE__*/React.createElement(AKInlineDialog, {
      content: content,
      isOpen: isOpen,
      onClose: this.handleContentBlur,
      onContentBlur: this.handleContentBlur,
      testId: "inline-dialog"
    }, /*#__PURE__*/React.createElement("span", {
      tabIndex: 0,
      onFocus: this.handleFocus,
      role: "tooltip"
    }, children)));
  }
}
_defineProperty(RichTooltip, "defaultProps", {
  delay: 200
});